import { registerModule } from 'ps-gui';
import ActivationModel from './activation/activationmodel';
import ActivationModule from './activation/activationmodule';
import AuthenticationCodeModel from './authenticationcode/authenticationcodemodel';
import AuthenticationCodeModule from './authenticationcode/authenticationcodemodule';
import DashboardModel from './dashboardmodel';
import DashboardModule from './dashboardmodule';
import LoginModel from './login/loginmodel';
import LoginModule from './login/loginmodule';
import MainPageModel from './mainpagemodel';
import MainPageModule from './mainpagemodule';
import MyRecordingsModel from './myrecordingsmodel';
import MyRecordingsModule from './myrecordingsmodule';
import NotificationAdminModel from './notificationadminmodel';
import NotificationAdminModule from './notificationadminmodule';
import NotificationModel from './notificationmodel';
import NotificationModule from './notificationmodule';
import PortalResultSetModule from './portalresultsetmodule';
import SessionLogModel from './sessionlogmodel';
import SessionLogModule from './sessionlogmodule';
import SubmissionAdminModel from './submissionadminmodel';
import SubmissionAdminModule from './submissionadminmodule';
import SubmissionModel from './submissionmodel';
import SubmissionModule from './submissionmodule';
import SystemMaintenanceModel from './systemmaintenancemodel';
import SystemMaintenanceModule from './systemmaintenancemodule';
import SystemSettingsModel from './systemsettingsmodel';
import SystemSettingsModule from './systemsettingsmodule';
import UsageReportModel from './usagereportmodel';
import UsageReportModule from './usagereportmodule';
import UserAdminModel from './useradminmodel';
import UserAdminModule from './useradminmodule';
import UserProfileModel from './userprofile/userprofilemodel';
import UserProfileModule from './userprofile/userprofilemodule';
import BankIdModule from './bankidmodule';
import BankIdModel from './bankidmodel';
import AffirmationSubmissionSettingsModule from './affsubsettings/affirmationsubmissionsettingsmodule';
import AffirmationSubmissionSettingsModel from './affsubsettings/affirmationsubmissionsettingsmodel';
import AffirmationSubmissionModel from './affsub/affirmationsubmissionmodel';
import AffirmationSubmissionModule from './affsub/affirmationsubmissionmodule';
import AffirmationSubmissionAdminModel from './affsub/affirmationsubmissionadminmodel';
import AffirmationSubmissionAdminModule from './affsub/affirmationsubmissionadminmodule';
import AffirmationDistributionResultModule from './affirmationdistributionresultmodule';
import AffirmationDistributionResultModel from './affirmationdistributionresultmodel';
import CatalogRecordingModel from './catalogrecordingmodel';
import CatalogRecordingModule from './catalogrecordingmodule';
import RecordingProtocolDetailModule from './recordingprotocol/recordingprotocoldetailmodule';
import RecordingProtocolDetailModel from './recordingprotocol/recordingprotocoldetailmodel';
import RecordingProtocolAdminModel from './recordingprotocol/recordingprotocoladminmodel';
import RecordingProtocolAdminModule from './recordingprotocol/recordingprotocoladminmodule';
import IsrcProtocolModule from './isrcprotocol/isrcprotocolmodule';
import IsrcProtocolModel from './isrcprotocol/isrcprotocolmodel';
import DocumentModule from './documentmodule';
import DocumentModel from './documentmodel';
import LabelModule from './label/labelmodule';
import LabelModel from './label/labelmodel';
import LabelAdminModule from './label/labeladminmodule';
import LabelAdminModel from './label/labeladminmodel';

export function registerModules() {
	registerModule('Dashboard', DashboardModule, DashboardModel);
	registerModule('MainPage', MainPageModule, MainPageModel);
	registerModule('SystemSettings', SystemSettingsModule, SystemSettingsModel);
	registerModule('NotificationAdmin', NotificationAdminModule, NotificationAdminModel);
	registerModule('SessionLog', SessionLogModule, SessionLogModel);
	registerModule('MyRecordings', MyRecordingsModule, MyRecordingsModel);
	registerModule('UsageReport', UsageReportModule, UsageReportModel);
	registerModule('Notifications', NotificationModule, NotificationModel);
	registerModule('PortalResultSet', PortalResultSetModule, null);
	registerModule('UserProfile', UserProfileModule, UserProfileModel);
	registerModule('SystemMaintenance', SystemMaintenanceModule, SystemMaintenanceModel);
	registerModule('UserAdmin', UserAdminModule, UserAdminModel);
	registerModule('Login', LoginModule, LoginModel);
	registerModule('Activation', ActivationModule, ActivationModel);
	registerModule('AuthenticationCode', AuthenticationCodeModule, AuthenticationCodeModel);
	registerModule('Submission', SubmissionModule, SubmissionModel);
	registerModule('SubmissionAdmin', SubmissionAdminModule, SubmissionAdminModel);
	registerModule('BankId', BankIdModule, BankIdModel);
	registerModule('AffirmationSubmissionSettings', AffirmationSubmissionSettingsModule, AffirmationSubmissionSettingsModel);
	registerModule('AffirmationSubmission', AffirmationSubmissionModule, AffirmationSubmissionModel);
	registerModule('AffirmationSubmissionAdmin', AffirmationSubmissionAdminModule, AffirmationSubmissionAdminModel);
	registerModule('AffirmationDistributionResult', AffirmationDistributionResultModule, AffirmationDistributionResultModel);
	registerModule('CatalogRecording', CatalogRecordingModule, CatalogRecordingModel);
	registerModule('RecordingProtocolDetail', RecordingProtocolDetailModule, RecordingProtocolDetailModel);
	registerModule('RecordingProtocolAdmin', RecordingProtocolAdminModule, RecordingProtocolAdminModel);
	registerModule('Document', DocumentModule, DocumentModel);
	registerModule('IsrcProtocol', IsrcProtocolModule, IsrcProtocolModel);
	registerModule('Label', LabelModule, LabelModel);
	registerModule('LabelAdmin', LabelAdminModule, LabelAdminModel);
}
